import { ConfigFile, Setting } from "./ProjectConfig";
export var isUndefined = function isUndefined(comp) {
  return comp === undefined;
};
export function getSettingsFromConfig(json) {
  return Object.fromEntries(Object.entries(json[ConfigFile.FeatureFlags]).map(function (_a) {
    var key = _a[0],
        value = _a[1];
    return [key, Setting.fromJson(value)];
  }));
}